import { useMemo } from 'react';
import MangaCard from '@/components/MangaCard';
import { mangaList } from '@/mocks/manga';

interface FeaturedProps {
  query: string;
}

export default function Featured({ query }: FeaturedProps) {
  const filtered = useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) return [...mangaList].sort((a, b) => b.rating - a.rating).slice(0, 6);
    return mangaList.filter((m) => {
      const hay = `${m.title} ${m.author} ${m.genre} ${m.tags.join(' ')}`.toLowerCase();
      return hay.includes(q);
    });
  }, [query]);

  return (
    <section id="featured" className="mx-auto w-full max-w-7xl scroll-mt-20 px-4 py-16 md:px-6 md:py-24">
      <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
        <div>
          <span className="text-sm font-medium text-primary-600">FEATURED PICKS</span>
          <h2 className="mt-2 font-heading text-2xl text-foreground-950 md:text-4xl">热门佳作推荐</h2>
          <p className="mt-3 max-w-xl text-sm leading-relaxed text-foreground-600 md:text-base">
            编辑部与漫友共同甄选的高质量漫画，从口碑、剧情到画面全面把关，闭眼入的安心之选。
          </p>
        </div>
        {query.trim() && (
          <p className="text-sm text-foreground-500">
            搜索「{query.trim()}」共找到 <span className="font-semibold text-primary-600">{filtered.length}</span> 部作品
          </p>
        )}
      </div>

      {filtered.length > 0 ? (
        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3">
          {filtered.map((item) => (
            <MangaCard key={item.id} item={item} />
          ))}
        </div>
      ) : (
        <div className="mt-10 flex flex-col items-center justify-center rounded-lg border border-dashed border-background-300 bg-background-100 py-16 text-center">
          <i className="ri-file-search-line text-4xl text-secondary-400" aria-hidden="true"></i>
          <p className="mt-4 text-base font-medium text-foreground-800">暂时没有找到匹配的漫画</p>
          <p className="mt-1 text-sm text-foreground-600">换个关键词试试，比如「治愈」「热血」或作品名。</p>
          <a
            href="#genres"
            className="mt-5 inline-flex items-center gap-1.5 rounded-md bg-secondary-500 px-4 py-2 text-sm font-medium text-background-50 whitespace-nowrap hover:bg-secondary-600"
          >
            浏览主题分类
          </a>
        </div>
      )}
    </section>
  );
}